import { render, staticRenderFns } from "./AreaManageDialog.component.vue?vue&type=template&id=17f71ebc&scoped=true"
import script from "./AreaManageDialog.component.vue?vue&type=script&lang=js"
export * from "./AreaManageDialog.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f71ebc",
  null
  
)

export default component.exports